module.exports = __webpack_public_path__ + "static/media/media6.7c4dc189.jpeg";